import { type LocalizationKey } from '~src/i18n/use-translation';

type OrderSource = 'COS:V2' | 'DEMO' | 'SOM' | 'COS' | 'TRACKING';

const formattedSource: Record<OrderSource, LocalizationKey> = {
  'COS:V2': 'transportOrders.list.sourceCheckout',
  COS: 'transportOrders.list.sourceCheckout',
  DEMO: 'transportOrders.list.sourceDemo',
  SOM: 'transportOrders.list.sourceTa',
  TRACKING: 'transportOrders.list.sourceTracking',
};

export const getSourceLabel = (source?: string): LocalizationKey => {
  if (!source || !Object.keys(formattedSource).includes(source.toUpperCase())) {
    return 'transportOrders.list.sourceUnknown';
  }

  return formattedSource[source.toUpperCase() as OrderSource];
};
